import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    async loadChildren() {
      const m = await import('./components/layout/layout.routes');
      return m.routes;
    },
    canActivate: [authGuard],
  },
];
